import styled from "styled-components";
import {
  BackgroundImage,
  ImageSkeleton,
  PriceContainer,
  isWhite,
} from "./menu-item.styles.jsx";

export const SquareImageSkeleton = styled(ImageSkeleton)`
  border-radius: 0;
`;

export const SquareBackgroundImage = styled(BackgroundImage)`
  border-radius: 0;
`;

export const SquareMenuItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 0;
  flex: 1 1 0%;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  background: ${({ cardBackground }) => cardBackground};
  border: 1px solid
    ${({ cardBackground }) =>
      isWhite(cardBackground) ? "#eaecf0" : "transparent"};
  box-shadow: ${({ cardBackground }) =>
    isWhite(cardBackground)
      ? "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
      : "none"};
`;

export const SquareImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  max-height: 200px;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
`;

export const SquareNameContainer = styled.span`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ brandTertiary, soldOut }) =>
    soldOut ? `${brandTertiary}80` : brandTertiary};
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const SquareDescriptionContainer = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: ${({ textBody, soldOut }) => (soldOut ? `${textBody}80` : textBody)};
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;

  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

export const SquareImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ placeholderBackground }) =>
    placeholderBackground || "#e5e7eb"};
  color: ${({ iconColor }) => iconColor || "#98a2b3"};
`;

export const SquareSoldOutOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  pointer-events: none;
`;

export const SquareContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 12px;
  min-height: 96px;

  @media screen and (max-width: 768px) {
    padding: 10px;
  }
`;

export const SquareFooter = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 8px;
`;

export const SquarePriceContainer = styled(PriceContainer)`
  font-size: 16px;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;
